import React from 'react';
import { SETTINGS, STATES } from 'modules/emergencies/constants';
import BlueText from 'modules/emergencies/components/ui/texts/BlueText';
import RegularText from 'modules/emergencies/components/ui/texts/RegularText';
import BodyColumn from 'modules/emergencies/components/ui/columns/bodyColumn';
import { useHistory } from 'react-router-dom';
import ticketService from 'modules/emergencies/ticketService';
import styled from 'styled-components';
import Ball from 'modules/emergencies/components/ui/ball/ball';
import { ReactComponent as ExclamationRedIcon } from 'assets/icons/xpo/status_icons/girded-exclamation-red.svg';
import TooltipHeader from 'modules/emergencies/components/ui/texts/TooltipHeader';
import { Tooltip } from '@ontruck/orc';

const CustomBlueText = styled(BlueText)`
  font-size: 14px;
  font-weight: 500;
`;

const CustomRegularText = styled(RegularText)`
  font-size: 12px;
  font-weight: 500;
`;

const FloatingIcon = styled.div`
  position: absolute;
  right: 5px;
  top: 5px;
`;

const t = {
  [STATES.DONE]: 'MOVED > TMS',
  [STATES.PENDING]: 'PENDING',
  [STATES.DRAFT]: 'DRAFT',
  [STATES.CANCELLED]: 'CANCELLED',
  [STATES.ACCEPTED]: 'ACCEPTED',
  [STATES.CREATED]: 'CREATED',
  [STATES.QUOTE_SENT]: 'QUOTE SENT',
  [STATES.REJECTED]: 'REJECTED',
  [STATES.EXPIRED]: 'EXPIRED',
  notification_error: 'Message could not be sent to the customer',
};
export const TicketColumn = ({ ticket }) => {
  const history = useHistory();
  const ticketColor = ticketService.bussiness.getTicketColor(ticket);

  let displayedState = t[ticket.synthetic_state];

  const hasNotificationError =
    !!ticket.has_failing_power_2_email || !!ticket.has_failing_power_2_whatsapp;

  return (
    <BodyColumn
      width={SETTINGS.TICKETS_TABLE_COLUMN_SIZES_IN_PX.TICKET}
      columnBorderLeftColor={ticketColor}
      onClick={() => {
        history.push(`/emergencies/${ticket.id}`);
      }}
    >
      {hasNotificationError && (
        <Tooltip
          component={<TooltipHeader>{t.notification_error}</TooltipHeader>}
          position="right"
          skin="dark"
        >
          <FloatingIcon>
            <ExclamationRedIcon />
          </FloatingIcon>
        </Tooltip>
      )}

      <CustomBlueText>ID. {ticketService.utils.getFormatedId(ticket.id)} </CustomBlueText>
      <CustomRegularText>
        <Ball backgroundColor={ticketColor} />
        {displayedState}
      </CustomRegularText>
    </BodyColumn>
  );
};
